import comp from "./StandardsSelectionModal";
export default comp;
